import React from 'react';
import {
  Box,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import { ExchangeRate } from '../../../types/finance';
import ExchangeRatesTable from './ExchangeRatesTable';

interface ExchangeRatesProps {
  rates: ExchangeRate[];
  loading: boolean;
  error: string | null;
  onDelete: (item: ExchangeRate) => void;
}

const ExchangeRates: React.FC<ExchangeRatesProps> = ({ rates, loading, error, onDelete }) => {

  const columns = [
    { field: 'currency', label: 'Валюта' },
    { field: 'rate', label: 'Курс' },
    { 
      field: 'date_update', 
      label: 'Дата обновления',
      render: (value: string) => new Date(value).toLocaleString()
    }
  ];

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5">Курсы валют</Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <ExchangeRatesTable
          data={rates}
          columns={columns}
          onDelete={onDelete}
        />
      )}
    </Box>
  );
};

export default ExchangeRates; 